import { render, staticRenderFns } from "./teamperformanceprolive.vue?vue&type=template&id=97b66a50&"
import script from "./teamperformanceprolive.vue?vue&type=script&lang=js&"
export * from "./teamperformanceprolive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports